import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API_CUST = process.env.API_CUST;

const RefundReceipt = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const res = await axios.get(`${API_CUST}/job/${jobId}`);
        setJob(res.data);
      } catch (err) {
        console.error("❌ Failed to fetch job:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchJob();
  }, [jobId]);

  if (loading) return <p className="text-center mt-8">Loading receipt...</p>;
  if (!job) return <p className="text-center mt-8 text-red-600">Job not found.</p>;

  const refund = job.refundAmount?.toFixed(2) || "0.00";
  const totalPaid = job.assignedPrice || job.budget || "0.00";
  const fee = (parseFloat(totalPaid) - parseFloat(refund)).toFixed(2);
  const cancelledAt = new Date(job.cancelledAt || job.updatedAt).toLocaleString();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6">
      <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-xl border">
        <h1 className="text-3xl font-bold text-red-600 mb-4 text-center">Refund Receipt</h1>

        <div className="text-lg space-y-3">
          <p><strong>Service:</strong> {job.serviceType || job.jobTitle || job.category || "N/A"}</p>
          <p><strong>Job ID:</strong> <span className="text-gray-800">{job._id}</span></p>
          <p><strong>Stripe Payment ID:</strong> <span className="text-gray-800">{job.stripePaymentId || "N/A"}</span></p>
          <p><strong>Original Amount Paid:</strong> ${totalPaid}</p>
          <p><strong>Cancellation Fee:</strong> ${fee}</p>
          <p><strong>Refund Amount:</strong> <span className="text-green-700 font-semibold">${refund}</span></p>
          <p><strong>Refund Status:</strong> {job.paymentStatus}</p>
          <p><strong>Cancelled On:</strong> {cancelledAt}</p>
        </div>

        <button
          onClick={() => navigate("/your-jobs")}
          className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded"
        >
          Back to My Jobs
        </button>
      </div>
    </div>
  );
};

export default RefundReceipt;
